import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-5 space-y-3 pl-6" }
const _hoisted_2 = { class: "relative scroll-mt-24" }
const _hoisted_3 = { class: "flex flex-wrap justify-between" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-x-4 gap-y-2" }
const _hoisted_5 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = { class: "mb-2 sm:mb-0" }
const _hoisted_9 = { class: "rounded border-gray-200 bg-gray-50 px-1.5 py-0.5 text-xs ring-1 ring-gray-300" }
const _hoisted_10 = { class: "flex items-center space-x-1 text-sm" }
const _hoisted_11 = {
  key: 0,
  class: "truncate"
}
const _hoisted_12 = {
  key: 1,
  class: "truncate"
}
const _hoisted_13 = {
  key: 2,
  class: "truncate"
}
const _hoisted_14 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_15 = { class: "flex items-center lg:justify-end" }
const _hoisted_16 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_17 = { class: "mt-3 flex flex-wrap items-center gap-2" }
const _hoisted_18 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["ring-background absolute -left-[31px] top-5 h-2.5 w-2.5 rounded-full", $setup.sentiment.bulletTone])
      }, null, 2 /* CLASS */),
      _createVNode(_component_UiPanel, { class: "hover:bg-white" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode($setup["CalendarIcon"], {
                  class: "h-4 w-4",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", _hoisted_6, _toDisplayString($setup.formatDateAsString($props.call.startedAt.toString(), 'DD/MM/YYYY')), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.formatDateAsString($props.call.startedAt.toString(), 'HH:mm:ss')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`call.type.${$props.call.type}`)), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode($setup["UserIcon"], {
                  class: "h-4 w-4",
                  "aria-hidden": "true"
                }),
                ($setup.sourceEvent?.sourceUser)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.sourceEvent?.sourceUser?.name), 1 /* TEXT */))
                  : ($setup.destinationEvent?.destinationUser)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.destinationEvent?.destinationUser?.name), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode($setup["ClockIcon"], {
                  class: "h-4 w-4",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.duration')) + ": ", 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($props.call.status == $setup.CallStatus.ANSWERED && $props.call.endedAt
                                    ? $setup.formatSecToTime($setup.duration)
                                    : '-'), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (
                                $props.showViewButton &&
                                _ctx.$can($setup.Permission.VIEW_CALL) &&
                                $props.call.status === 'ANSWERED'
                            )
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "primary",
                    to: {
                                name: 'ViewCallById',
                                params: {
                                    id: $props.call.id,
                                },
                            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["PlayIcon"], {
                        class: "h-7 w-7",
                        "aria-hidden": "true"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.actions.View')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"])), [
                    [_directive_tippy, _ctx.$t('core.actions.View')]
                  ])
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_16, _toDisplayString($props.call.summary?.summaryText ?? _ctx.$t('call.list.noSummary')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium", $setup.sentiment.tone])
            }, [
              ($setup.sentiment.face)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.sentiment.face), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t($setup.sentiment.label)), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}